<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="750">
      <v-card>
        <v-card-title>
          Выберите устройство
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                class="btn__icon pa-0"
                width="18"
                height="18"
                @click="close"
              >
                <v-icon size="x-large">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card-title>
        <v-col class="px-5 pb-5">
          <v-text-field
            v-model='searchValue'
            @input="searchAddress"
            placeholder="Поиск по адресу или id"
            solo
            outlined
            dense
            hide-details
            flat
          ></v-text-field>
        </v-col>
        <v-data-table
          class="table"
          :headers="headersDoorphone"
          :items="searchDooprhone"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-options': [10, 20, 50, 100],
          }"
        >
          <template v-slot:item.status="{ item }">
            <div>
              <v-icon x-small :color="item.sip_status_color">
                mdi-checkbox-blank-circle
              </v-icon>
              {{ item.sip_status_text }}
            </div>
          </template>
          <template v-slot:item.address="{ item }">
            <div v-if="!item.type">
              {{ item.address }}, {{ displayType(item.passage_type) }}
            </div>
            <div v-else>
              {{ item.address }}
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-row align="center">
              <v-col cols=12>
                <v-row justify="center">
                  <v-btn
                    color="#1E6CEB"
                    class="text-none"
                    dense
                    icon
                    @click="startAddingMarker(item)"
                  >
                    <v-icon color="green" >mdi-map-marker-right-outline</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  props: {
    searchDooprhone: {
      type: Array,
    },
    isAddingMarker: {
      type: Boolean,
      required: true,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      searchValue: '',
      headersDoorphone: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address' },
        { text: 'Агент', value: 'agent' },
        { text: 'Статус', value: 'status' },
        { text: '', value: 'actions' },
      ],
    };
  },
  methods: {
    displayType (item) {
      switch (item) {
        case 'B': return '(Шлагбаум)';
        case 'G': return '(Ворота)';
        default: return '';
      }
    },
    searchAddress () {
      this.$emit('searchAddressDoorphone', this.searchValue);
    },
    startAddingMarker (item) {
      this.$emit('startAddingMarker', item);
    },
    async close () {
      await this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
</style>
